// ─── components/UI/PasswordInput.jsx ─────────────────────────────────────────
// A password <input> with a show/hide toggle, so a typo isn’t discovered only
// after submitting. Drop-in replacement for <input type="password" ... /> —
// forwards every other prop (value, onChange, className, id, autoComplete...)
// straight through. paddingRight is set inline (not a class) so it always
// wins over whatever padding the caller's className already sets, regardless
// of Tailwind's generated rule order.
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PiEye, PiEyeSlash } from 'react-icons/pi';

export default function PasswordInput({ className, style, ...inputProps }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        {...inputProps}
        type={visible ? 'text' : 'password'}
        className={className}
        style={{ paddingRight: 40, ...style }}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-press-muted transition hover:text-press-ink"
      >
        {visible ? <PiEyeSlash size={16} aria-hidden="true" /> : <PiEye size={16} aria-hidden="true" />}
      </button>
    </div>
  );
}

PasswordInput.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};
